import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';

export default class PlayerName {
  constructor() {
    document
      .querySelector('#playerNameSubmit_btn')
      .addEventListener('click', this.onPlayerName_btn.bind(this));
  }

  init() {
    this.isChecked = true;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    // setTimeout(()=>{
    //     this.onOkay();
    // }, 1000)
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  showScreen(screenKey) {
    if (screenKey != 'PlayerName') return false;

    this.pageAnimation();
    document.querySelector('#playerName_scr').classList.add('active');
  }

  pageAnimation() {
    gsap.set('#playerNameSubmit_btn', { opacity: 0 });

    gsap.fromTo(
      '#playerName_scr > .appContainer',
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );

    setTimeout(() => {
      setTimeout(() => {
        this.events.dispatchEvent({
          type: 'ANIMATION_EVENTS',
          message: {
            event_type: 'buttonAnimation',
            data: {
              selector: '#playerNameSubmit_btn',
            },
          },
        });
      }, 1000);
    }, 500);
  }

  hideControls() {}

  onPlay() {
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'Home',
        },
      },
    });
  }

  onPlayerName_btn() {
    const firstname = document.getElementById('playerName').value;
    if (firstname.length <= 0) {
      showError(Global.language.nameError[Global.lang]);
    } else {
      Global.playerName = firstname;

      this.onProceed();
      Global.clickUpdater('playerNameSubmit_btn');
    }
    function showError(msg) {
      document.querySelector('#errorPlayerName').innerHTML = msg;
      document.querySelector('#errorPlayerName').classList.add('active');
    }
  }
  onProceed() {
    document.querySelector('#playerName_scr').classList.remove('active');
    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
      DeviceOrientationEvent.requestPermission()
        .then((permissionState) => {
          if (permissionState === 'granted') {
            Global.deviceOrientationAvailable = true;
            this.enableCamera();
          } else {
          }
        })
        .catch(console.error);
    } else {
      Global.deviceOrientationAvailable = true;
      this.enableCamera();
    }
  }
  enableCamera() {
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'gyro_permission_update',
        data: {},
      },
    });
    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: 'environment',
        },
      })
      .then((stream) => {
        // Get the video element
        const videoElement = document.getElementById('cameraView');

        // Set the video source to the stream from the camera
        videoElement.srcObject = stream;

        this.events.dispatchEvent({
          type: 'LOADER_EVENTS',
          message: {
            event_type: 'switch_page',
            data: {
              screenKey: 'GameInst',
            },
          },
        });
      })
      .catch((error) => {
        console.log('Error accessing the camera: ', error);
      });
  }

  onOkay() {
    document.querySelector('#score_sec').classList.add('active');
    document.querySelector('#instr_scr').classList.remove('active');
    setTimeout(() => {
      // document.querySelector(".game_footer").classList.add("active2");
      document.querySelector('.game_timer_sec').classList.add('active');
    }, 100);
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'level_selected',
        data: {
          level: 1,
        },
      },
    });
  }
}
